import styled from 'styled-components'

export default styled.aside`
  flex: 0 0 200px;
  width: 200px;
`



// WEBPACK FOOTER //
// ./src/components/HeaderSidebarLayout/Sidebar.js